import React from "react";
import SweetAlert from "react-bootstrap-sweetalert";

/**
 * SweetAlert com a aparencia das telas de agendamento.
 *
 * A biblioteca aplica todo o visual por estilo inline e usa `btn-lg` nos
 * botoes, o que resulta em titulo de 30px, icone de 80px e botoes enormes.
 * Este wrapper neutraliza o tamanho dos botoes e marca o modal com a classe
 * `sched-alert`, de onde o CSS assume o restante (ver assets/scss/scheduling.scss).
 *
 * Existe para que o ajuste fique restrito ao allScheduling: as paginas legadas
 * seguem usando SweetAlert direto, sem alteracao.
 *
 * Aceita as mesmas props do SweetAlert.
 */
export default function SchedulingAlert({
  customClass = "",
  afterMount,
  ...props
}) {
  return (
    <SweetAlert
      // A biblioteca foca o botao confirmar ao abrir, e o Chrome trata foco
      // programatico como :focus-visible — o anel acendia sozinho, sem ninguem
      // ter interagido. O foco vai para o proprio dialogo (abaixo), que nao e
      // acionavel e por isso nao acende anel nenhum.
      focusConfirmBtn={false}
      {...props}
      afterMount={() => {
        // Mantem o dialogo com o foco, para o Escape e os leitores de tela
        // continuarem funcionando em vez de deixar o foco na pagina atras.
        document
          .querySelector(".sched-alert")
          ?.focus({ preventScroll: true });
        afterMount?.();
      }}
      customClass={`sched-alert ${customClass}`.trim()}
      btnSize=""
      confirmBtnCssClass="sched-alert-btn sched-alert-btn-confirm"
      cancelBtnCssClass="sched-alert-btn sched-alert-btn-cancel"
    />
  );
}
